import { render, staticRenderFns } from "./feeDetailCar.vue?vue&type=template&id=e1b43742"
import script from "./feeDetailCar.vue?vue&type=script&lang=js"
export * from "./feeDetailCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports